export default "__VITE_ASSET__8570adf8__"